<script setup lang="ts">
import { LuvButton } from "@polargold/luv-ui-library";
import { useI18n } from "vue-i18n";

import { useAppVersionStore } from "@/stores/appVersionStore";

const { t } = useI18n();
const appVersionStore = useAppVersionStore();
</script>

<template>
    <Transition name="fade">
        <div
            v-if="appVersionStore.updateAvailable"
            class="footer-shadow fixed bottom-0 left-0 right-0 z-[1100] flex items-center justify-center gap-4 bg-luv-white p-4"
        >
            <span>{{ t("COMPONENTS.APP_UPDATE_BANNER.MESSAGE") }}</span>
            <LuvButton button-style="primary" @click="appVersionStore.applyUpdate">
                {{ t("COMPONENTS.APP_UPDATE_BANNER.BUTTON") }}
            </LuvButton>
        </div>
    </Transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
